const accessibilityButton = document.querySelector('.top-nav__button--accessibility')

// accessibilityButton.addEventListener('click', ()=> {
//     UserWay.widgetToggle();
// })

// $(function(){
//     var topNavButton = $('.top-nav__accessibility');

//     topNavButton.one('click', function() {
//         $(this).addClass('top-nav__accessibility--loading');
//         $.getScript("https://usrwy.com/widget.js");
//     })

//     document.addEventListener("userway:render_completed", function() {
//         topNavButton.removeClass('top-nav__accessibility--loading');
//         UserWay.widgetToggle();

//         topNavButton.click(function() {
//             UserWay.widgetToggle();
//         })

//     });
// })